import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SupportContactService } from '../../../services/support-contact.service';

@Component({
  selector: 'app-insufficient-rights',
  imports: [],
  templateUrl: './insufficient-rights.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './insufficient-rights.component.scss',
})
export class InsufficientRightsComponent implements OnInit {
  public mailLink = '';

  private supportContactService = inject(SupportContactService);

  public ngOnInit(): void {
    this.mailLink = this.supportContactService.getSupportMailLink("\nThe error 'Insufficient Rights' occurred");
  }
}
